import React, { useState, useEffect } from 'react';
import { translations } from '../../translations';
import logo from '../Assets/insta-car-spa.png';
import './Header.css';

const Header = ({ language = 'en' }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const t = translations[language]?.nav || translations.en.nav;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: t.home, href: '#H' },
    { label: t.services, href: '#c' },
    { label: t.about, href: '#A' },
    { label: t.pricing, href: '#p' },
    { label: t.gallery, href: '#g' },
    { label: t.contact, href: '#C' },
  ];

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container">
        <div className="header__logo">
          <img
            src={logo}
            alt="InstaCarSpa Logo"
          />
        </div>
        <button
          className="header__toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle Menu"
        >
          <span className="header__toggle-icon"></span>
        </button>
        <nav className={`header__nav ${isMenuOpen ? 'header__nav--open' : ''}`}>
          <ul className="header__menu">
            {menuItems.map((item, index) => (
              <li key={index} className="header__menu-item">
                <a
                  href={item.href}
                  className="header__menu-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
